import { createSlice } from "@reduxjs/toolkit";
import ApiAnalytics from "../../api/analytics";

const buildRequestKey = (query = {}) => {
  const { page, ...requestScope } = query || {};
  return JSON.stringify(requestScope);
};

export const AuditAnalyticsSlice = createSlice({
  name: "task-analytics",
  initialState: {
    analytics: [],
    hasMore: false,
    isLoading: false,
    requestKey: null,
  },
  reducers: {
    setAnalytics: (state, action) => {
      const payload = Array.isArray(action.payload)
        ? { analytics: action.payload }
        : action.payload || {};
      const requestKey = payload.requestKey;

      if (requestKey && state.requestKey !== requestKey) {
        return state;
      }

      const analytics = Array.isArray(payload.analytics) ? payload.analytics : [];
      const newAnalytics = analytics.filter(
        (newItem) => !state.analytics.some((existingItem) => existingItem.id === newItem.id)
      );
      return {
        ...state,
        analytics: state.analytics ? [...state.analytics, ...newAnalytics] : newAnalytics,
        hasMore: Boolean(payload.hasMore),
        isLoading: false,
      };
    },
    resetAnalytics: (state, action) => {
      const requestKey = action.payload?.requestKey;

      if (requestKey && state.requestKey !== requestKey) {
        return state;
      }

      return {
        ...state,
        analytics: [],
        hasMore: false,
        isLoading: false,
        requestKey: requestKey || null,
      };
    },
    setLoading: (state, action) => ({
      ...state,
      isLoading: true,
      requestKey: action.payload?.requestKey || null,
    }),
  },
});

export const { setAnalytics, resetAnalytics, setLoading } = AuditAnalyticsSlice.actions;

export const fetchAnalytics = (query) => (dispatch) => {
  const requestKey = buildRequestKey(query);
  dispatch(setLoading({ requestKey }));
  ApiAnalytics.getTaskAnalytics(query)
    .then((r) => {
      const analytics = Array.isArray(r.data?.analytics) ? r.data.analytics : [];
      const fallbackHasMore = analytics.length >= Number(query?.limit || 200);
      dispatch(setAnalytics({
        analytics,
        hasMore: r.data?.hasMore ?? fallbackHasMore,
        requestKey,
      }));
    })
    .catch(() => {
      dispatch(resetAnalytics({ requestKey }));
    });
};

export const clearAnalytics = () => (dispatch) => {
  dispatch(resetAnalytics());
};

export const selectAnalytics = (state) => state.taskAnalytics.analytics;
export const selecthasMoreAnalytics = (state) => state.taskAnalytics.hasMore;
export const selectAnalyticsLoading = (state) => state.taskAnalytics.isLoading;

export default AuditAnalyticsSlice.reducer;
